export interface VennCircle {
  id: string;
  label: string;
  color?: string;
}

export interface VennIntersection {
  sets: string[];
  label: string;
}

export interface VennDiagramData {
  title: string;
  circles: VennCircle[];
  intersections: VennIntersection[];
}

export const VENN_DEFAULT_COLORS = ["#f59e0b", "#8b5cf6", "#3b82f6"];

export function parseVennDiagramBlock(jsonStr: string): VennDiagramData | null {
  try {
    const raw = JSON.parse(jsonStr);

    if (
      typeof raw.title !== "string" ||
      !Array.isArray(raw.circles) ||
      raw.circles.length < 2 ||
      raw.circles.length > 3 ||
      !Array.isArray(raw.intersections)
    )
      return null;

    for (const c of raw.circles) {
      if (typeof c.id !== "string" || typeof c.label !== "string") return null;
    }

    const validIds = new Set(raw.circles.map((c: any) => c.id));

    for (const inter of raw.intersections) {
      if (!Array.isArray(inter.sets) || typeof inter.label !== "string") return null;
      for (const s of inter.sets) {
        if (!validIds.has(s)) return null;
      }
    }

    const circles: VennCircle[] = raw.circles.map((c: any, i: number) => ({
      id: c.id,
      label: c.label,
      color: c.color || VENN_DEFAULT_COLORS[i % VENN_DEFAULT_COLORS.length],
    }));

    const intersections: VennIntersection[] = raw.intersections.map((inter: any) => ({
      sets: inter.sets,
      label: inter.label,
    }));

    return { title: raw.title, circles, intersections };
  } catch {
    return null;
  }
}
